import {dictionary as ptBr} from './pt_BR';

export const dictionary = {
  pt_BR: ptBr,
};
